import { useState, useEffect } from 'react'

export function useDebounce<T>(v: T, delay = 250): T {
    const [d, setD] = useState(v)
    useEffect(() => {
        const id = setTimeout(() => setD(v), delay)
        return () => clearTimeout(id)
    }, [v, delay])
    return d
}